import { createContext, useContext } from "react";
import { useToast, UseToastOptions } from "@chakra-ui/react";

const AlertsContext = createContext<any | null>(null);

const AlertsConsumer = AlertsContext.Consumer;

function AlertsProvider({ children }: { children: JSX.Element }) {
    const toast = useToast();

    const showError = ({
        title = "Error Occured",
        description = "Something went wrong, and the request failed.",
    }: {
        title: string;
        description: string;
    }) => {
        showAlert({
            title,
            description,
            status: "error",
        });
    };

    const showSuccess = ({
        title = "Request Completed",
        description = "The request was successful!",
    }: {
        title: string;
        description: string;
    }) => {
        showAlert({
            title,
            description,
            status: "success",
            variant: "subtle",
            containerStyle: {
                border: "1px",
                borderRadius: "7px",
                borderColor: "#45C14A",
            },
        });
    };

    const showAlert = (data: UseToastOptions) => {
        toast({
            ...data,
            isClosable: true,
        });
    };

    return (
        <AlertsContext.Provider
            value={{
                showSuccess,
                showError,
            }}
        >
            <>{children}</>
        </AlertsContext.Provider>
    );
}
export { AlertsContext, AlertsConsumer, AlertsProvider };
export const useAlertsContext = () => useContext(AlertsContext);
